var app = angular.module("leonardo");

var CategoryListFilters = function(
  $scope,
  $controller,
  $state,
  SectorRestService
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.filters_options = [
    {
      id: 'sector',
      name: 'Sector',
      label: null,
      inline: false,
      type: 'options',
      multiple: false,
      placeholder: 'Select sector',
      condition: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
      service: SectorRestService,
      conflicts: ['category']
    },
    {
      id: 'category_name',
      name: $state.current.subcategory ? 'Subcategory Name' : 'Category Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: $state.current.subcategory ? 'Subcategory name' : 'Category name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];

};

app.controller('CategoryListFilters', [
  '$scope',
  '$controller',
  '$state',
  'SectorRestService',
  CategoryListFilters
]);
